export class Util {


    static safeString(str: string | null | undefined): string {
        if (!str) {
            return '';
        }
        return str;
    }

    static safeNumber(nullableNumber: number | null | undefined): number {
        if (!nullableNumber) {
            return 0;
        }
        return nullableNumber;
    }

    static arrayContains<T>(element: T | null | undefined, array: Array<T> | null | undefined): boolean {
        if (!array || !element) {
            return false;
        }
        return array.indexOf(element) >= 0;
    }

    static swap<T>(index1: number, index2: number, array: Array<T>): void {
        const tmp = array[index1];
        array[index1] = array[index2];
        array[index2] = tmp;
    }
}